/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueGaugeTakeOffServiceComponent } from './sysque-gauge-take-off-service.component';
import { FormsModule } from '@angular/forms';
import { AngularDraggableModule } from 'angular2-draggable';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/sysque-gauge-takeoff-dialog', component: SysqueGaugeTakeOffServiceComponent }];

@NgModule({
  declarations: [SysqueGaugeTakeOffServiceComponent],
  imports: [CommonModule, FormsModule, AngularDraggableModule, AlertModule, RouterModule.forChild(routes)],
  exports: [SysqueGaugeTakeOffServiceComponent],
})
export class SysqueGaugeTakeOffServiceModule {}
